<!--
회원사 주문정보란? 안내 라벨 컴포넌트
---------------------------------------

-->
<template>
    <div class="uk-inline uk-position-relative">
        <!-- 라벨 -->
        <span class="uk-label uk-label-white" @mouseenter="openView" @mouseleave="closeView">
            회원사 주문정보란?
        </span>

        <!-- 팝업 -->
        <div class="popup" :class="popupDirection" v-show="viewDisplay">
            회원사 주문정보 란 ?<br /><br />
            주문이 접수된 마켓(Gmarket, 스토어팜)정보로 회원사 참고용입니다.
        </div>
    </div>

</template>

<script>
    import Base from './base.vue';

    export default {
        extends: Base,
    }
</script>

<style lang="scss" scoped>
    @import './base';
    .popup {
        width: 350px;
    }
</style>